import React from 'react';
import { useNavigate } from 'react-router-dom';
import LMSHeader from '../components/LMSHeader';

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <>
      <LMSHeader />
      <div className="min-h-screen bg-gradient-to-br from-neutral-50 to-neutral-100 dark:from-neutral-900 dark:to-neutral-800 flex flex-col items-center justify-center px-4 py-12">
        <div className="text-center max-w-md">

          <div className="relative">
            <div className="text-9xl font-bold text-neutral-800 dark:text-neutral-200 mb-4">404</div>
            <div className="absolute inset-0 flex items-center justify-center -top-2 -left-2">
              <div className="text-9xl font-bold text-primary-100 dark:text-primary-900/20">404</div>
            </div>
          </div>

          <h1 className="text-3xl font-bold text-neutral-900 dark:text-white mb-4">
            Page Not Found
          </h1>
          <p className="text-lg text-neutral-600 dark:text-neutral-400 mb-8">
            Oops! The page you're looking for doesn't exist or has been moved.
          </p>

          <div className="space-y-4">
            <button
              onClick={() => navigate('/')}
              className="w-full py-3 px-6 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-lg transition duration-200 shadow-md"
            >
              Go to Homepage
            </button>
            <button
              onClick={() => navigate(-1)}
              className="w-full py-3 px-6 bg-white dark:bg-neutral-800 border border-neutral-300 dark:border-neutral-700 text-neutral-800 dark:text-white font-medium rounded-lg hover:bg-neutral-50 dark:hover:bg-neutral-700 transition"
            >
              Go Back
            </button>
          </div>

          <div className="mt-12 text-neutral-500 dark:text-neutral-500 text-sm">
            <p>Need help? Contact us at</p>
            <a
              href="mailto:training@boleum.com"
              className="font-medium text-primary-600 hover:text-primary-700 dark:text-primary-400"
            >
              training@boleum.com
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotFoundPage;